import { isEmpty } from 'lodash';
// @mui
import { Box, Typography, Stack, Button } from '@mui/material';
// assets
import { UploadIllustration } from '../../assets';
import Iconify from '../Iconify';

// ----------------------------------------------------------------------

export default function BlockContent({ file, preview, disabled, small }) {

  return (
    <Stack
      spacing={2}
      alignItems="center"
      justifyContent="center"
      direction={{ xs: 'column', md: 'row' }}
      sx={{ width: 1, textAlign: { xs: 'center', md: 'left' } }}
    >
      {!isEmpty(file) || !isEmpty(preview) || disabled ?
        <Stack
          alignItems='center'
          spacing={1}
          justifyContent='center'
          sx={{ height: '215px' }}
        >
          <Iconify icon='ant-design:file-outlined' height='100px' width='100px' />
          <Typography variant='subtitle2' width='80%' align='center'>{typeof file === 'object' ? file.path : 'Uploaded'}</Typography>
        </Stack>
        :
        <Box sx={{ p: small ? 1 : 3 }}>
          {!small && <Typography gutterBottom variant="h5">
            Drop or Select file
          </Typography>}

          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Drop files here or click&nbsp;
            <Typography
              variant="body2"
              component="span"
              sx={{ color: 'primary.main', textDecoration: 'underline', }}>
              browse
            </Typography>
            &nbsp;thorough your machine
          </Typography>
        </Box>
      }


    </Stack>
  );
}
